import { BooleanFilterOperationType } from 'module/types/filter-field/filter/boolean';
import { FormattedMessage } from 'react-intl';

export const booleanTriggerOptionRenderers = (
  operationType: BooleanFilterOperationType,
): null | React.JSX.Element => {
  switch (operationType) {
    case BooleanFilterOperationType.IsTrue: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_true" />
      );
    }

    case BooleanFilterOperationType.IsFalse: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_false" />
      );
    }

    case BooleanFilterOperationType.IsEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_empty" />
      );
    }

    case BooleanFilterOperationType.IsNotEmpty: {
      return (
        <FormattedMessage id="settings.integrations.sf.trigger.option.is_not_empty" />
      );
    }

    default: {
      return null;
    }
  }
};
